export default function ProductModal({ product, close }) {
  return (
    <div className="modal-backdrop-custom" onClick={close}>
      
      <div
        className="modal-card modal-layout"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-btn" onClick={close}>×</button>

        <div className="modal-image">
          <img src={product.image} alt={product.name} />
        </div>

        <div className="modal-content">
          <h3>{product.name}</h3>

          <p><strong>Category:</strong> {product.category}</p>
          <p><strong>Technical Name:</strong> {product.technical}</p>
          <p><strong>Formulation:</strong> {product.formulation}</p>
          <p><strong>Pack Size:</strong> {product.packSize}</p>
        </div>
      </div>
    </div>
  );
}
